import React, {useState} from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Image from 'react-bootstrap/Image';

/**
 * DropdownButton Component with support for child buttons
 * @param {string} label - Main button label text
 * @param {string} icon - Optional icon path for the main button
 * @param {Array} items - Array of dropdown items with {id, text, icon, onClick, children} properties
 * @param {string} variant - Bootstrap button variant (default: 'default')
 * @param {string} className - Additional CSS classes
 */
function DropdownButton({
                            parentClick,
                            childClick,
                            label,
                            icon,
                            items = [],
                            variant = 'default',
                            className = '',
                            buttonClassName = ''
                        }) {
    const [showDropdown, setShowDropdown] = useState(false);
    const [expandedItems, setExpandedItems] = useState({});

    const handleItemClick = (item, e) => {
        if (item.children && item.children.length > 0) {
            e.stopPropagation();
            const isCurrentlyExpanded = expandedItems[item.id];
            setExpandedItems({
                [item.id]: !isCurrentlyExpanded
            });
            return;
        }

        parentClick(item);
        setShowDropdown(false);
        setExpandedItems({});
    };

    const handleChildClick = (child, parentItem) => {
        childClick(child, parentItem);
        setShowDropdown(false);
        setExpandedItems({});
    };

    const renderItem = (item, level = 0) => {
        const hasChildren = item.children && item.children.length > 0;
        const isExpanded = expandedItems[item.id];

        return (
            <React.Fragment key={item.id}>
                <Dropdown.Item
                    onClick={(e) => handleItemClick(item, e)}
                    className={`d-flex align-items-center justify-content-between py-2 ${level > 0 ? 'ps-4' : ''}`}
                    style={{paddingLeft: level > 0 ? `${level}rem` : undefined}}
                >
                    <span className="d-flex align-items-center">
                        {item.icon && (
                            <Image
                                src={item.icon}
                                alt={item.text}
                                width="16"
                                height="16"
                                className="me-2"
                            />
                        )}
                        <span>{item.text}</span>
                    </span>
                    {hasChildren && (
                        <Image
                            src={isExpanded ? "/svg/chevron-up.svg" : "/svg/chevron-down.svg"}
                            alt="toggle"
                            width="12"
                            height="12"
                            className="ms-2"
                        />
                    )}
                </Dropdown.Item>

                {hasChildren && isExpanded && (
                    <div className="dropdown-submenu">
                        {item.children.map((child) => (
                            <Dropdown.Item
                                key={child.id}
                                onClick={() => handleChildClick(child, item)}
                                className="d-flex align-items-center py-1 ps-4"
                            >
                                {child.icon && (
                                    <Image
                                        src={child.icon}
                                        alt={child.text}
                                        width="14"
                                        height="14"
                                        className="me-2"
                                    />
                                )}
                                {child.cssImage && (
                                    <span
                                        className={child.cssImage}
                                    />
                                )}
                                <span>{child.text}</span>
                            </Dropdown.Item>
                        ))}
                    </div>
                )}
            </React.Fragment>
        );
    };

    return (
        <Dropdown
            className={className}
            autoClose="outside"
            show={showDropdown}
            onToggle={(isOpen) => {
                setShowDropdown(isOpen);
                if (!isOpen) setExpandedItems({});
            }}
        >
            <Dropdown.Toggle
                variant={variant}
                className={`cc-border-dark d-flex justify-content-between align-items-center text-secondary ${buttonClassName}`}
                onClick={() => setShowDropdown(!showDropdown)}
            >
                <span className="d-flex align-items-center">
                    {icon && (
                        <Image
                            src={icon}
                            alt={label}
                            width="16"
                            height="16"
                            className="me-2"
                        />
                    )}
                    {label}
                </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="shadow-sm border-0">
                {items.map((item) => renderItem(item))}
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default DropdownButton;